import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfilePut } from "#job-profile/services/api"
import { Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function ApproveDialog({ open, setOpen, profileData, refresh }) {
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setOpen(false)
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfilePut, { success, end })

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabled,
			},
			{
				label: "habilitar",
				onClick: () => {
					setDisabled(true)
					fetch(profileData.id, { habilitado: true })
				},
				disabled: disabled,
			},
		],
		[disabled, setOpen, fetch, profileData.id]
	)

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: <>habilitar</>,
					buttons,
				}}
			>
				<Typography color="text.primary" sx={{ textTransform: "uppercase" }}>
					¿Está seguro que desea Habilitar el perfil de puesto
					<strong> {profileData.nombre}</strong>?
				</Typography>
				<br />
				<Typography
					color="text.primary"
					variant="subtitle2"
					sx={{ textTransform: "uppercase" }}
				>
					Esto permitirá que se pueda utilizar el perfil de puesto en la plataforma.
				</Typography>
			</MasterDialog>
		</Fragment>
	)
}
